import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComments } from '@fortawesome/free-solid-svg-icons';

const EmptyState: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="chat-empty-state">
      <div className="chat-empty-state__icon">
        <FontAwesomeIcon icon={faComments} />
      </div>
      <h4>{t('chat.selectConversation', 'Select a conversation')}</h4>
      <p>{t('chat.selectConversationDesc', 'Choose a conversation from the list or start a new one')}</p>
    </div>
  );
};

export default EmptyState;
